import clsx from 'clsx';
import {CheckCircleBoldIcon} from '@solar-icons/react';
import styles from './BalanceWidget.module.css';

const LEFT_ONES = Array.from({length: 8});
const RIGHT_N_BLOCKS = Array.from({length: 4});

/** n + 10 = 5n + 2, solved by removing equal pieces from both trays. Resolves to n = 2 by default. */
export default function BalanceWidget({playing}) {
    return (
        <>
            <span className={styles.title}><em>n</em> + 10 = 5<em>n</em> + 2</span>
            <div className={styles.scale}>
                <div className={styles.stand}>
                    <div className={styles.gauge}>
                        <span className={styles.needle}/>
                        <span className={styles.gaugeDot}/>
                    </div>
                    <span className={styles.balancedLabel}>BALANCED</span>
                </div>
                <div className={styles.beam}/>
                <div className={clsx(styles.trayBar, styles.trayBarLeft)}/>
                <div className={clsx(styles.trayBar, styles.trayBarRight)}/>

                <div className={clsx(styles.tray, styles.trayLeft)}>
                    <span className={clsx(styles.nBlock, styles.removable, playing && styles.gone1)}><em>n</em></span>
                    {LEFT_ONES.map((_, i) => (
                        <span key={i} className={styles.unit}>1</span>
                    ))}
                    <span className={clsx(styles.unit, styles.removable, playing && styles.gone2)}>1</span>
                    <span className={clsx(styles.unit, styles.removable, playing && styles.gone2)}>1</span>
                </div>

                <div className={clsx(styles.tray, styles.trayRight)}>
                    <span className={clsx(styles.nBlock, styles.removable, playing && styles.gone1)}><em>n</em></span>
                    {RIGHT_N_BLOCKS.map((_, i) => (
                        <span key={i} className={styles.nBlock}><em>n</em></span>
                    ))}
                    <span className={clsx(styles.unit, styles.removable, playing && styles.gone2)}>1</span>
                    <span className={clsx(styles.unit, styles.removable, playing && styles.gone2)}>1</span>
                </div>
            </div>
            <div className={styles.answerRow}>
                <em>n</em>
                <span>=</span>
                <div className={styles.answerBox}>
                    <span className={clsx(styles.answerDigit, playing && styles.rise)}>2</span>
                </div>
                <CheckCircleBoldIcon
                    size={26}
                    color="var(--color-feedback-correct-vivid)"
                    className={clsx(styles.tick, playing && styles.pop)}
                />
            </div>
        </>
    );
}
